module.exports = __webpack_public_path__ + "img/Group 125.ac5431e2.svg";